import { KYMW0600Model } from '../kymw0600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * Pコードを指定し、商品情報を取得するクラス
 *
 * @export UpdateRelationPcodeService
 * @class UpdateRelationPcodeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateRelationPcodeService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0600Model;
  private vo: Array<any>;
  private colseFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateRelationPcodeService
   */
  private getBody(): PlessRequest {

    const updateParam = {
      PCode: "",
      RelationPcodeOld: "",
      RelationPcodeNew: "",
    };
    this.model.relatedGoodsList.forEach((element, ind) => {
      if (ind == 1) {
        updateParam.PCode = element.pCode;
      } else if (ind == 0) {
        updateParam.RelationPcodeNew = element.pCode;
      } else if (ind == 2) {
        updateParam.RelationPcodeOld = element.pCode;
      }
    });

    return new PlessRequest({ parameter: updateParam });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateRelationPcodeService
   */
  execute(model: KYMW0600Model, closeFunc: Function = null): void {
    this.model = model;
    this.colseFunc = closeFunc;
    this.send('updateRelationPcode', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateRelationPcodeService
   */
  success(): void {
    this.dialogService.openAlertGetMessage('I0513', [''],
      (closeDetail: any): void => {
        if (closeDetail === PlessAlert.Yes) {
          // ダイアログを閉じる
          this.colseFunc();
        }
      });    
    // 親画面にデータを返却する
    this.model.kymw0600Component.updateParent();
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(): void {
    this.dialogService.openAlertGetMessage('E0540', [''],
      (closeDetail: any): void => {
        if (closeDetail === PlessAlert.Yes_Error) {
          // ダイアログを閉じる
          this.colseFunc();
        }
     });
  }
}
